import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import { UserProvider } from "@/lib/userAuth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";
import Home from "@/pages/Home";
import Listing from "@/pages/Listing";
import WaterfallDetail from "@/pages/WaterfallDetail";
import SeoCategory from "@/pages/SeoCategory";
import BestOf from "@/pages/BestOf";
import Safety from "@/pages/Safety";
import About from "@/pages/About";
import Saved from "@/pages/Saved";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminEditWaterfall from "@/pages/AdminEditWaterfall";
import AdminModeration from "@/pages/AdminModeration";
import AdminErrorReports from "@/pages/AdminErrorReports";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // Fire a GA4 page_view on every client-side route change. The base config in
    // index.html has send_page_view disabled so we control exactly when this fires.
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname + window.location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname]);
  return null;
}

function HomeLayout() { return (<><Navbar transparentOnHero /><Outlet /><Footer /></>); }
function InnerLayout() { return (<><Navbar withSearch /><Outlet /><Footer /></>); }
function AdminLayout() { return <Outlet />; }

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <UserProvider>
            <ScrollToTop />
            <BackToTop />
            <Routes>
              {/* Auth callback — handles session_id in URL hash */}
              <Route path="/auth/callback" element={<AuthCallback />} />

              <Route element={<HomeLayout />}>
                <Route path="/" element={<Home />} />
              </Route>
              <Route element={<InnerLayout />}>
                <Route path="/waterfalls" element={<Listing />} />
                <Route path="/waterfalls/:slug" element={<WaterfallDetail />} />
                <Route path="/best-waterfalls" element={<BestOf />} />
                <Route path="/best-waterfalls-in/:kind/:slug" element={<SeoCategory />} />
                <Route path="/safety" element={<Safety />} />
                <Route path="/about" element={<About />} />
                <Route path="/saved" element={<Saved />} />
              </Route>
              <Route element={<AdminLayout />}>
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/reviews" element={<AdminModeration />} />
                <Route path="/admin/error-reports" element={<AdminErrorReports />} />
                <Route path="/admin/waterfalls/:id" element={<AdminEditWaterfall />} />
              </Route>
            </Routes>
          </UserProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
